export default {
  populate: {
    owner: {
      fields: "id",
    },
    image: true,
    gallery: true,
    localizations: true,
    rate_plans: {
      fields: "id",
    },
    accommodation_services: true,
    accommodation_type: {
      populate: "localizations",
    },
    facility: {
      fields: ["id", "businessName"],
    },
  },
};
